// @flow
import React, { useCallback } from 'react';

import { OrderPayment } from 'app/common/components/Shop';


type Props = {
  params: {
    id: string,
    number: string,
  },
  push: (path: string) => void
}

const PaymentPage = ({ params, push }: Props) => {
  const { id, number } = params;
  const handleReturnToOrdersHistory = useCallback(() => {
    push('/shop/history');
  }, [push]);

  return (
    <OrderPayment
      onReturnToOrdersHistory={handleReturnToOrdersHistory}
      orderId={id}
      number={number}
    />
  );
};

export default PaymentPage;
